import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../../hoc/StyledTitle';
import ToolTip from '../AssetPropertyView';

@StyledTitle
class Div extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    tooltipStyle: PropTypes.object
  };

  render() {
    const { children, tooltipStyle, title, ...props } = this.props;
    return (
      <div name="Div" {...props}>
        <ToolTip text={title} style={{ overflow: 'hidden', textOverflow: 'ellipsis', ...tooltipStyle }}>
          {children}
        </ToolTip>
      </div>
    );
  }
}

export default Div;
